import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './Core/Layout/layout.component';
import { ProgressComponent } from './components/progress/progress.component';
import { QuoteEmailLandingComponent } from './components/email-landing/quote-email-landing/quote-email-landing.component';
import { RedirectorGuard } from './Core/redirector-guard/redirector-guard';

const routes: Routes = [
  { path: 'seguros-decesos/calcular', component: LayoutComponent, canActivate: [RedirectorGuard], pathMatch: 'full' },
  { path: 'datos-comparativa', component: LayoutComponent, canActivate: [RedirectorGuard], pathMatch: 'full' },
  { path: 'datos-comparativa.aspx', redirectTo: 'datos-comparativa', pathMatch: 'full' },
  { path: 'progress', component: ProgressComponent, pathMatch: 'full' },
  // Redirect all old email landings to the new email-landing component
  { path: 'email-quotes-landing.aspx', redirectTo: 'email-landing', pathMatch: 'full' },
  { path: 'email-landing/quote', redirectTo: 'email-landing', pathMatch: 'full' },
  { path: 'email-landing', component: QuoteEmailLandingComponent, pathMatch: 'full' },
  {
    path: 'modifica-tus-datos',
    component: LayoutComponent, pathMatch: 'full'
  },
  // TODO : UnComment Wildcard handling of URL. Disabled for Development Purpose
  { path: '**', redirectTo: 'datos-comparativa', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
